/**
 * Created by shaun on 16/09/2017.
 */

import {EMPTY, ERROR, LOADING, READY} from 'module/constants';
import common from 'module/common';

const SET_STATE = 'state';
const SET_PROVIDERS = 'setProviders';
const SET_CATEGORIES = 'setCategories';
const SET_SUPPLIERS_BY_CATEGORY = 'setSuppliersByCategory';

// initial state
const state = {
    state: EMPTY,
    providers: [],
    allCategories: [],
    suppliersByCategory: []
};

//actions
const actions = {
    load({state, dispatch, commit, rootGetters}) {
        if (['portal'].includes(rootGetters['environment/route']) === false) {
            //Not needed for this environment
            return;
        }

        commit(SET_STATE, LOADING);

        let idToken = rootGetters['user/idToken']();

        common
            .httpGet('externalProvider')
            .idToken(idToken || null)
            .then((res) => {
                commit(SET_PROVIDERS, res.data);
                commit(SET_STATE, READY);
            }, ({data}) => {
                commit(SET_STATE, ERROR);
            });
    },
    getCategoriesWithSuppliersForBranch({state, dispatch, commit, rootGetters}, branch) {
        if (['portal'].includes(rootGetters['environment/route']) === false || branch === null) {
            //Not needed for this environment
            return;
        }

        commit(SET_STATE, LOADING);
        commit(SET_CATEGORIES, {});
        commit(SET_SUPPLIERS_BY_CATEGORY, {});

        let idToken = rootGetters['user/idToken']();

        return new Promise((resolve) => {
            common
                .httpPost('externalProvider')
                .data({branch: branch})
                .idToken(idToken || null)
                .then((res) => {
                    commit(SET_CATEGORIES, res.data);
                    commit(SET_SUPPLIERS_BY_CATEGORY, res.data);
                    commit(SET_STATE, READY);
                    resolve(res);
                }, () => {
                    commit(SET_STATE, ERROR);
                    resolve(null);
                });
        });
    }
};

//getters
const getters = {
    allCategories(state) {
        return state.allCategories
    },
    suppliersByCategory: (state) => (category) => {
        const categoryWithSuppliers = _.find(state.suppliersByCategory, ['name', category]);
        return categoryWithSuppliers !== undefined ? categoryWithSuppliers.suppliers : [];
    },
};

// mutations
const mutations = {
    [SET_STATE](state, newState) {
        state.state = newState;
    },
    [SET_PROVIDERS](state, data) {
        state.providers = _.get(data, 'providers', []);
    },
    [SET_CATEGORIES](state, data) {
        state.allCategories = _.get(data, 'allCategories', []);
    },
    [SET_SUPPLIERS_BY_CATEGORY](state, data) {
        state.suppliersByCategory = _.get(data, 'suppliersByCategory', []);
    }
};

export default {
    state,
    actions,
    getters,
    mutations
}
